// Copyright © 2021 Move Closer

import { Component, Prop, Vue } from 'vue-property-decorator'

import { ContentSneakPeakData } from '../../../_contracts'
import { TileSize } from '../Tile.contracts'

/**
 * Tile category component
 * Displays article's parent category name
 */
@Component<TileCategory>({
  name: 'TileCategory',
  template: `
    <span v-if="shouldShow" class="tile__category">
      {{ article.parent.name }}
    </span>
  `
})
export class TileCategory extends Vue {
  @Prop({
    type: Object,
    required: true
  })
  public readonly article!: ContentSneakPeakData

  @Prop({
    type: Boolean,
    required: true
  })
  public readonly showCategory!: boolean

  @Prop({
    type: String,
    required: true
  })
  public readonly size!: TileSize

  /**
   * Determines whether category should be shown
   */
  public get shouldShow (): boolean {
    if (this.size === TileSize.S) {
      return false
    }
    return !!(this.showCategory && this.hasParent)
  }

  /**
   * Determines whether there's a parent category to be rendered
   */
  private get hasParent (): boolean {
    return (
      typeof this.article.parent !== 'undefined' &&
      this.article.parent !== null &&
      typeof this.article.parent.name === 'string' &&
      this.article.parent.name.length > 0
    )
  }
}
